import React, { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { MODAL_NAME_AUTH } from '../../constants/modalNamesConstants';
import { useModal } from '../../hooks/useModal';
import {
  AuthModalPayloadType, AuthStateType, LOGIN_STATE_TYPE, REGISTER_STATE_TYPE, RESET_PASSWORD_STATE_TYPE
} from './authTypes';
import ModalComponent from '../../core/components/modal/ModalComponent';
import { LoginContainer } from './login/LoginContainer';
import { RegisterContainer } from './register/RegisterContainer';
import { ResetPasswordContainer } from './resetPassword/ResetPasswordContainer';
import TabComponent from '../../core/components/tab/TabComponent';

const AuthModalContainer: FC = () => {
  const { t } = useTranslation();
  const { onCloseModal, payload = {} } = useModal(MODAL_NAME_AUTH);
  const { selectedAuthStateType } = payload as AuthModalPayloadType;
  const [authStateType, setAuthStateType] = useState<AuthStateType>(selectedAuthStateType || LOGIN_STATE_TYPE);

  const modalTitles = {
    [LOGIN_STATE_TYPE]: t('auth.login'),
    [REGISTER_STATE_TYPE]: t('auth.register'),
    [RESET_PASSWORD_STATE_TYPE]: t('auth.resetPassword'),
  };

  const tabs = [
    {
      id: LOGIN_STATE_TYPE,
      title: t('auth.login'),
      Content: <LoginContainer onCloseModal={onCloseModal} onSwitchToResetPassword={() => setAuthStateType(RESET_PASSWORD_STATE_TYPE)} />,
      onChange: () => setAuthStateType(LOGIN_STATE_TYPE)
    },
    {
      id: REGISTER_STATE_TYPE,
      title: t('auth.register'),
      Content: <RegisterContainer onCloseModal={onCloseModal} />,
      onChange: () => setAuthStateType(REGISTER_STATE_TYPE)
    },
  ];

  if (authStateType === RESET_PASSWORD_STATE_TYPE) {
    tabs.push({
      id: RESET_PASSWORD_STATE_TYPE,
      title: t('auth.resetPassword'),
      Content: <ResetPasswordContainer onCloseModal={onCloseModal} />,
      onChange: () => setAuthStateType(RESET_PASSWORD_STATE_TYPE)
    });
  }

  return (
    <ModalComponent title={modalTitles[authStateType]} onClose={onCloseModal}>
      <TabComponent tabs={tabs} activeTabId={authStateType} />
    </ModalComponent>
  );
};

export default AuthModalContainer;
